/** The dock compass over the hovered tab group, and a preview of where the window would go. */
import { For, Show, type JSX } from "solid-js";
import { COMPASS, ZONES, type Target } from "./geometry";

/** The compass over the hovered group and a preview of where the window would go. */
export function DropOverlay(props: { target: Target }): JSX.Element {
  /** The rectangle the window would take if dropped now. */
  const preview = () => {
    const { rect, zone } = props.target;
    if (!zone) return null;
    const half = { left: [0, 0, 0.5, 1], right: [0.5, 0, 0.5, 1], top: [0, 0, 1, 0.5], bottom: [0, 0.5, 1, 0.5], center: [0, 0, 1, 1] }[zone];
    return { left: `${rect.x + rect.w * half[0]!}px`, top: `${rect.y + rect.h * half[1]!}px`, width: `${rect.w * half[2]!}px`, height: `${rect.h * half[3]!}px` };
  };
  return (
    <div class="drop-layer">
      <Show when={preview()}>{(style) => <div class="drop-preview" style={style()} />}</Show>
      <For each={ZONES}>
        {([zone, dx, dy]) => (
          <div
            class="compass"
            classList={{ on: props.target.zone === zone, center: zone === "center" }}
            data-zone={zone}
            style={{
              left: `${props.target.rect.x + props.target.rect.w / 2 + dx * COMPASS.step - COMPASS.size / 2}px`,
              top: `${props.target.rect.y + props.target.rect.h / 2 + dy * COMPASS.step - COMPASS.size / 2}px`,
              width: `${COMPASS.size}px`,
              height: `${COMPASS.size}px`,
            }}
          />
        )}
      </For>
    </div>
  );
}
